type OperationDefinitionLike = {
  kind: string;
  operation?: string;
};

/** True when the document's primary operation is a GraphQL mutation. */
export function isGraphqlMutationDocument(document: {
  readonly definitions: readonly OperationDefinitionLike[];
}): boolean {
  return document.definitions.some(
    (definition) =>
      definition.kind === 'OperationDefinition' &&
      definition.operation === 'mutation',
  );
}
